<template lang="">
  <div>
    <v-dialog v-model="dialog" width="620px">
      <BaseBodyDialog 
        :title="`THÊM ${$route.meta.title}`"
        :loading="loading"
        @close="cancel"
        @save="save"
      >
        <headFeeNewForm ref="form" />
      </BaseBodyDialog>
    </v-dialog>
  </div>
</template>

<script>
import headFeeNewForm from '../../../components/basic/form/headFeeNewForm.vue'
import BaseBodyDialog from '../../../components/basic/dialog/BaseBodyDialog.vue'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    headFeeNewForm,
    BaseBodyDialog
  },
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false,
      loading: false,
      isBtnSave: false
    }
  },
  computed: {
    ...mapState('tuitonFeeHeadFee', ['router', 'isSubFee'])
  },
  methods: {
    ...mapActions('tuitonFeeHeadFee', ['createHeadFees']),
    cancel() {
      this.reset()
      this.dialog = false
    },
    reset() {
      this.$refs.form.reset()
    },
    async save() {
      this.loading = true
      const data = this.$refs.form.getData()
      if (data) {
        this.isBtnSave = true
        await this.createHeadFees(data)
        this.reset()
        this.$emit('addHeadFeeSuccess')
        this.dialog = false
        this.isBtnSave = false
      }
      this.loading = false
    }
  },
  watch: {
    state() {
      this.dialog = true
    }
  }
}
</script>
